export const routers = [
  {
    path: '/home-page',
    redirect: '/',
  },
  {
    path: '/',
    name: 'Main',
    redirect: '/',
    meta: {
      title: '',
    },
    component: () => import('@/components/main'),
    children: [
      // 首页
      {
        path: '/',
        name: 'home-page',
        meta: {
          title: '首页',
        },
        component: () => import('@/views/home-page'),
      },
      // 关于兴芮
      {
        path: '/xingrui-management',
        name: 'xingrui-management',
        redirect: '/xingrui-management/group-introduction',
        meta: {
          title: '关于兴芮',
        },
        component: () => import('@/views/xingrui-management'),
        children: [
          {
            path: "/xingrui-management/group-introduction",
            name: "group-introduction",
            meta: {
              title: '集团介绍',
            },
            component: () => import('@/views/xingrui-management/group-introduction'),
          },
          {
            path: "/xingrui-management/brand-concept",
            name: "brand-concept",
            meta: {
              title: '品牌理念',
            },
            component: () => import('@/views/xingrui-management/brand-concept'),
          },
          // {
          //   path: "/xingrui-management/strategic-layout",
          //   name: "strategic-layout",
          //   meta: {
          //     title: '战略布局',
          //   },
          //   component: () => import('@/views/xingrui-management/strategic-layout'),
          // },
          {
            path: "/xingrui-management/brand-honor",
            name: "brand-honor",
            meta: {
              title: '品牌荣誉',
            },
            component: () => import('@/views/xingrui-management/brand-honor'),
          },
        ],
      },
      // 业务板块
      {
        path: '/sector-management',
        name: 'sector-management',
        meta: {
          title: '业务板块'
        },
        redirect: '/sector-management/content-details',
        component: () => import('@/views/sector-management'),
        children: [
          {
            path: "/sector-management/content-details",
            name: "content-details",
            meta: {
              title: '内容详情'
            },
            component: () => import('@/views/sector-management/content-details'),
          },
        ],
      },
      // 新闻中心
      {
        path: '/central-management',
        name: 'central-management',
        redirect: '/central-management/group-news',
        component: () => import('@/views/central-management'),
        meta: {
          title: '新闻中心'
        },
        children: [
          {
            path: '/central-management/group-news',
            name: "group-news",
            meta: {
              title: '集团要闻'
            },
            component: () => import('@/views/central-management/group-news'),
          },
          {
            path: "/central-management/news-details/:id",
            name: "news-details",
            meta: {
              title: '新闻详情'
            },
            component: () => import('@/views/central-management/news-details'),
          },
          {
            path: "/central-management/media-coverage",
            name: "media-coverage",
            meta: {
              title: '媒体报道'
            },
            component: () => import('@/views/central-management/media-coverage'),
          },
          {
            path: "/central-management/social-media",
            name: "social-media",
            meta: {
              title: '社交媒体'
            },
            component: () => import('@/views/central-management/social-media'),
          }
        ],
      },
      // 加入我们
      {
        path: '/join-management',
        name: 'join-management',
        redirect: '/join-management/employee-style',
        meta: {
          title: '加入我们'
        },
        component: () => import('@/views/join-management'),
        children: [
          {
            path: "/join-management/employee-style",
            name: "employee-style",
            meta: {
              title: '员工风采'
            },
            component: () => import('@/views/join-management/employee-style'),
          },
          {
            path: "/join-management/apply",
            name: "apply",
            meta: {
              title: '我要应聘'
            },
            redirect: '/join-management/apply/my-apply',
            component: () => import('@/views/join-management/apply'),
            children: [
              {
                path: "/join-management/apply/my-apply",
                name: "my-apply",
                meta: {
                  title: ''
                },
                component: () => import('@/views/join-management/apply/my-apply'),
              },
              {
                path: "/join-management/apply/apply-details",
                name: "apply-details",
                meta: {
                  title: ''
                },
                component: () => import('@/views/join-management/apply/apply-details'),
              },
            ],
          },
        ],
      },
      // 招标公告
      {
        path: '/tender-announcement',
        name: 'tender-announcement',
        redirect: '/tender-announcement/tender-announcementinfo',
        component: () => import('@/views/tender-announcement'),
        meta: {
          title: '招标公告'
        },
        children: [
          {
            path: "/tender-announcement/tender-announcementinfo",
            name: "tender-announcementinfo",
            meta: {
              title: '招标公告'
            },
            component: () => import('@/views/tender-announcement/tender-announcementinfo'),
          },
          {
            path: "/tender-announcement/tender-announcement-details/:id",
            name: "tender-announcement-details",
            meta: {
              title: '招标公告详情'
            },
            component: () => import('@/views/tender-announcement/tender-announcement-details'),
          }
        ]
      },
      // 联系我们
      {
        path: '/contact-management',
        name: 'contact-management',
        redirect: '/contact-management/contact-information',
        component: () => import('@/views/contact-management'),
        meta: {
          title: '联系我们'
        },
        children: [
          {
            path: "/contact-management/contact-information",
            name: "contact-information",
            meta: {
              title: '联系方式'
            },
            component: () => import('@/views/contact-management/contact-information'),
          },
          {
            path: "/contact-management/leaving-message",
            name: "leaving-message",
            meta: {
              title: '给我们留言'
            },
            component: () => import('@/views/contact-management/leaving-message'),
          },
          // {
          //   path: "/contact-management/tender-announcement",
          //   name: "tender-announcement",
          //   meta: {
          //     title: '招标公告'
          //   },
          //   component: () => import('@/views/contact-management/tender-announcement'),
          // },
          // {
          //   path: "/contact-management/tender-announcement/tender-announcement-details/:id",
          //   name: "tender-announcement-details",
          //   meta: {
          //     title: '招标公告-招标公告详情'
          //   },
          //   component: () => import('@/views/contact-management/tender-announcement-details'),
          // }
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/routers.js